const ecosystem = [
    {
        id: 1,
        times: '10X',
        title: 'Faster',
        desc: 'Lightning-fast trading speed',
        image: '6.png'
    },
    {
        id: 2,
        times: '20X',
        title: 'Leverage',
        desc: 'Unleash your potential',
        image: '6.png'
    },
    {
        id: 3,
        times: '30%',
        title: 'Cheaper',
        desc: 'Experience low fees',
        image: '6.png'
    }
]

export default ecosystem;